import { FaUtensils } from "react-icons/fa";
import FoodDetailThemeBase from "./FoodDetailThemeBase";

const BLACK = "#0D0D0D";
const GOLD = "#C9A227";

const theme = {
  pageStyle: { backgroundColor: BLACK },
  headerClassName: "sticky top-0 z-20 border-b",
  headerStyle: { borderColor: "rgba(201,162,39,0.25)", backgroundColor: BLACK },
  headerInnerClassName: "mx-auto flex h-16 max-w-2xl items-center justify-between px-4",
  iconButtonClassName: "flex h-11 w-11 items-center justify-center rounded-xl text-xl text-white hover:bg-white/5",
  titleClassName: "font-serif font-black text-white",
  badgeClassName: "absolute -left-1 -top-1 rounded-full px-1.5 text-[10px] font-bold",
  badgeStyle: { backgroundColor: GOLD, color: BLACK },
  cardClassName: "overflow-hidden rounded-2xl border",
  cardStyle: { borderColor: "rgba(201,162,39,0.25)", backgroundColor: "#161616" },
  PlaceholderIcon: FaUtensils,
  placeholderClassName: "flex aspect-[4/3] items-center justify-center text-6xl sm:aspect-[16/9]",
  placeholderStyle: { color: GOLD },
  itemTitleClassName: "font-serif text-2xl font-black text-white",
  descriptionClassName: "mt-3 leading-7 text-white/50",
  priceStyle: { color: GOLD },
  stepperClassName: "flex items-center rounded-full border text-white",
  stepperStyle: { borderColor: "rgba(201,162,39,0.25)", backgroundColor: "#161616" },
  ctaClassName: "min-h-12 flex-1 rounded-full px-5 font-bold shadow-lg",
  ctaStyle: { backgroundColor: GOLD, color: BLACK },
};

const RoyalGoldFoodDetailTheme = (props) => <FoodDetailThemeBase {...props} theme={theme} />;

export default RoyalGoldFoodDetailTheme;
